import useApplicationStore from "@my-pages/stores/useApplicationStore.tsx";
import {backDoorMembership} from "@my-pages/utils/backDoorUtils.ts";
import {useGetApiV2MemberMembershipSuspense} from "@shared/integrations/taf-api/v2/features/member/member.ts";

const useGetMembership = () => {
    const backDoorEnabled = useApplicationStore((state) => state.backDoorEnabled);
    const { data } = backDoorEnabled ? { data: backDoorMembership } : useGetApiV2MemberMembershipSuspense();
    return data;
};

export default useGetMembership;
